var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ui-slider",
        {
          ref: "slickSetting2",
          staticClass: "video-slider arrow-appear--onload margin_top_sm",
          attrs: {
            options: {
              dots: false,
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              prevArrow:
                "<div class='video-arrow video-arrow--left video-arrow--white mdi mdi-chevron-left' aria-label='Previous'></div>",
              nextArrow:
                "<div class='video-arrow video-arrow--right video-arrow--white mdi mdi-chevron-right' aria-label='Next' style='display: block;'></div>",
              focusOnSelect: true,
              responsive: [{ breakpoint: 700, settings: { slidesToShow: 1 } }]
            }
          }
        },
        [
          _c(
            "template",
            { slot: "slide" },
            _vm._l(_vm.video, function(v, index) {
              return _c(
                "div",
                {
                  staticClass:
                    "video-slider-img video-slider-img--preview bgi-basic cursor-pointer"
                },
                [
                  _c("img", {
                    staticClass: "img-basic",
                    attrs: { src: _vm.getVideoPreview(v) }
                  }),
                  _c("div", {
                    staticClass:
                      "position_absolute mdi mdi-play-circle-outline color_white play-button z-index_10",
                    on: {
                      click: function($event) {
                        return _vm.showModal(index)
                      }
                    }
                  }),
                  _c("div", { staticClass: "mask position_absolute" })
                ]
              )
            }),
            0
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63a8b02d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a8b02d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/VideoSlider/VideoSlider.vue
// module id = 68
// module chunks = 0